<template>
  <div>
    <div class="row">
      <div class="col-md-12 header-row">
        <h3 class="heading semi-bold">All Fabrics</h3>
        <div class="row">
          <div class="col-md-3">
            <div class="input-group transparent">
              <span class="input-group-addon">
                <i class="fa fa-search" aria-hidden="true"></i>
              </span>
              <input
                type="text"
                class="form-control search-fabric"
                @keyup.enter="searchFabric($event.target.value)"
                placeholder="Search Fabric"
              />
            </div>
          </div>
          <div class="col-md-9 text-right">
            <router-link
              :to="{ path: '/fabric/listing/grid_view' }"
              class="btn btn-default"
            >
              <i class="fa fa-th" aria-hidden="true"></i> Grid View
            </router-link>
            <button class="btn btn-default" @click="showFabricColumnModal()">
              <i class="fa fa-cogs" aria-hidden="true"></i>
            </button>
            <router-link
              :to="{ name: 'fabric_create' }"
              class="btn shadow btn-primary create-new"
              v-if="!isReadOnlyUser"
            >
              <i class="fa fa-plus-circle" aria-hidden="true"></i> Create New
              Fabric
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- table -->
    <div class="row">
      <div class="col-md-12">
        <div
          class="grid bg-white added-margin shadow"
          style="padding-top: 20px"
        >
          <div class="grid-title">
            <h4>
              Total - {{ rows.length }} Fabric<span v-if="rows.length > 1"
                >s</span
              >
            </h4>
          </div>
          <div class="grid-body no-border">
            <div class="table-div">
              <table
                class="table table-bordered table-fabric-list-view"
                v-if="rows.length > 0"
              >
                <thead>
                  <tr>
                    <th>Image</th>
                    <th @click="sort('id')" class="sort">ID</th>
                    <th @click="sort('name')" class="sort">Name</th>
                    <th @click="sort('usage')" class="sort">Rank</th>
                    <th @click="sort('stock')" class="sort">In Stock</th>
                    <th @click="sort('total_rolls')" class="sort">Roll</th>
                    <th @click="sort('out_of_stock_date')" class="sort">
                      Oos date
                    </th>
                    <th @click="sort('delivery_date')" class="sort">
                      Delivery ?
                    </th>
                    <th @click="sort('status')" class="sort">Status</th>
                    <th @click="sort('fiber_1')" class="sort">Fiber 1</th>
                    <th @click="sort('fiber_1_percentage')" class="sort">
                      Fiber 1 %
                    </th>
                    <th @click="sort('fiber_2')" class="sort">Fiber 2</th>
                    <th @click="sort('fiber_2_percentage')" class="sort">
                      Fiber 2 %
                    </th>
                    <th
                      @click="sort(column)"
                      class="sort"
                      v-for="column in columnsToCompare"
                      :key="column"
                    >
                      {{ getColumnTitle(column) }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in rows" :key="row.id">
                    <td class="text-center">
                      <img :src="row.image_url" class="img" alt="" />
                    </td>
                    <td class="text-bold text-center">
                      <router-link
                        :to="{ name: 'fabric_update', params: { id: row.id } }"
                      >
                        {{ $Fabric.getCode(row.id) }}
                      </router-link>
                    </td>
                    <td class="text-center">
                      {{ row.name }}
                    </td>
                    <td class="text-center">
                      {{ row.rating }}
                    </td>
                    <td class="text-center">
                      {{ ezy.comma(row.stock) }}
                    </td>
                    <td class="text-center">
                      {{ row.total_rolls }}
                    </td>
                    <td class="text-center">
                      {{ row.out_of_stock_date }}
                    </td>
                    <td class="text-center">
                      {{ ezy.date(row.delivery_date) }}
                    </td>
                    <td class="text-center">
                      <span
                        :class="'badge badge-' + getStatusColor(row.status)"
                      >
                        {{ row.status.replace(/_/g, " ") }}
                      </span>
                    </td>
                    <td class="text-center">
                      {{ row.fiber_1 }}
                    </td>
                    <td class="text-center">{{ row.fiber_1_percentage }} %</td>
                    <td class="text-center">
                      <span
                        v-if="Number.parseInt(row.fiber_2_percentage) > 0"
                        >{{ row.fiber_2 }}</span
                      >
                    </td>
                    <td class="text-center">
                      <span v-if="Number.parseInt(row.fiber_2_percentage) > 0"
                        >{{ row.fiber_2_percentage }} %</span
                      >
                    </td>
                    <td
                      class="text-center"
                      v-for="column in columnsToCompare"
                      :key="column"
                    >
                      <span
                        v-if="column == 'threadColor' && row['thread_color']"
                      >
                        {{ row["thread_color"].internal_number }} -
                        {{ row["thread_color"].title_en }}
                      </span>
                      <span
                        v-else-if="
                          column == 'fabricCompositionLabel' &&
                          row['fabric_composition_label']
                        "
                      >
                        {{ row["fabric_composition_label"].label_name }}
                      </span>
                      <span
                        v-else-if="
                          column == 'buttonColor' && row['button_color']
                        "
                      >
                        {{ row["button_color"].internal_number }} -
                        {{ row["button_color"].title_en }}
                      </span>
                      <span
                        v-else-if="
                          column == 'embroideryThreadColor' &&
                          row['embroidery_thread_color']
                        "
                      >
                        {{ row["embroidery_thread_color"].internal_number }} -
                        {{ row["embroidery_thread_color"].title_en }}
                      </span>
                      <span
                        v-else-if="
                          column == 'fabricSupplier' && row['fabric_supplier']
                        "
                      >
                        {{ row["fabric_supplier"].name }}
                      </span>
                      <span
                        v-else-if="
                          column == 'default_vat_per_unit' && row[column]
                        "
                      >
                        {{ ezy.comma(row[column] / 100) }}
                      </span>
                      <span
                        v-else-if="
                          column == 'default_unit_price' && row[column]
                        "
                      >
                        {{ ezy.comma(row[column] / 100) }}
                      </span>
                      <span
                        v-else-if="
                          column == 'default_unit_price_total' && row[column]
                        "
                      >
                        {{ ezy.comma(row[column] / 100) }}
                      </span>
                      <span v-else-if="column == 'families' && row[column]">
                        {{
                          row[column]
                            .map((family) => {
                              return family.title_en;
                            })
                            .join(", ")
                        }}
                      </span>
                      <span
                        v-else-if="
                          [
                            'is_shirt_fabric',
                            'is_jersey_fabric',
                            'is_stretch_fabric',
                          ].indexOf(column) !== -1
                        "
                      >
                        {{ parseInt(row[column]) == 1 ? "Y" : "N" }}
                      </span>
                      <span v-else-if="column == 'matching'">
                        <span v-if="row[column]">Yes</span>
                        <span v-else>No</span>
                      </span>
                      <span v-else>
                        {{ row[column] }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- table -->
    <fabric-columns-modal
      v-model="columnsToCompare"
      @submit="submitChangedFabricColumn"
    />
  </div>
</template>
<script>
import { VueGoodTable } from "vue-good-table";
import Fabric from "@/pages/Tools/Fabric";
import FabricColumnsModal from "./components/FacbricColumnsModal";
import fabricColumns from "./tools/fabricColumns";
export default {
  mounted() {
    let tmp = localStorage.getItem("fabricColumnsToCompare");
    if (tmp && tmp !== "") {
      this.columnsToCompare = tmp.split(",");
    }
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    this.getFabricList();
  },
  components: {
    VueGoodTable,
    FabricColumnsModal,
  },
  data() {
    /**
     * Remove fiber_1, fiber_1_percentage, fiber_2, fiber_2_percentage from optionnal columns
     * because they are moved to default now.
     */
    let columnsToBeRemoved = [
      "fiber_1",
      "fiber_1_percentage",
      "fiber_2",
      "fiber_2_percentage",
    ];

    let optionalColumns = _.remove(fabricColumns, function (column) {
      return columnsToBeRemoved.includes(column.key);
    });

    return {
      Fabric,
      columnsToCompare: [],
      allColumnsToCompare: optionalColumns,
      isLoading: false,
      isReadOnlyUser: false,
      rows: [],
      sortType: "asc",
      rowsOriginal: [],
      fabricColumns: fabricColumns,
    };
  },
  methods: {
    showFabricColumnModal() {
      show_modal("#fabric-columns-modal");
    },

    submitChangedFabricColumn(columns) {
      this.columnsToCompare = columns;
      this.getFabricList();
    },

    getStatusColor(status) {
      if (["available"].includes(status)) {
        return "primary";
      } else if (
        ["soon_sold_out_not_coming_back", "soon_sold_out_coming_back"].includes(
          status
        )
      ) {
        return "warning";
      } else {
        return "danger";
      }
    },

    getColumnTitle(key) {
      if (key) {
        let column = this.fabricColumns.find(function (column) {
          return column.key === key;
        });
        return column.title;
      }
    },

    async getFabricList() {
      this.isLoading = true;

      /*
       * Default query parameters
       */
      let queryParams = {
        columns:
          "id,name,status,future,fiber_1,fiber_1_percentage,fiber_2,fiber_2_percentage,usage_type",
        custom_fields:
          "total_rolls,usage,stock,delivery_date,out_of_stock_date,rating,images",
        relationships:
          "images,threadColor,buttonColor,embroideryThreadColor,fabricSupplier,families,fabricCompositionLabel",
        per_page: 0,
      };

      /*
       * Extra columns added by the user
       */
      if (this.columnsToCompare) {
        queryParams.columns += "," + this.columnsToCompare.join(",");
      }

      let response = await axios.get("/v2/fabrics", {
        params: queryParams,
      });

      let collection = response.data.data.collection.map((f) => {
        f["oos_date_int"] = parseInt(f["out_of_stock_date"]);

        let outOfStockDate =
          f["oos_date_int"] > 0
            ? moment.unix(f["oos_date_int"]).format("DD MMM, YYYY")
            : "";

        if (f["oos_date_int"] < 0) {
          outOfStockDate = "No data";
        }

        f["out_of_stock_date"] = outOfStockDate;

        if (f["used_calculation_value"] && f["oos_date_int"] > 0) {
          f["out_of_stock_date"] =
            f["out_of_stock_date"] + " (" + f["used_calculation_value"] + ")";
        }

        return f;
      });

      let fabrics = collection.map((fabric) => {
        let images = fabric.images;
        if (images.length > 0) {
          // Use backend as main image
          let image = images.find((img) => {
            return img.type === "backend";
          });
          // Use the first image if the previous type is not found.
          if (!image) {
            image = images[0];
          }
          fabric["image_url"] = image.image_url;
        } else {
          fabric["image_url"] = "/assets/img/fabric-placeholder.png";
        }
        return fabric;
      });

      this.rows = fabrics;
      this.rowsOriginal = fabrics;
      this.isLoading = false;
      localStorage.setItem("fabricColumnsToCompare", this.columnsToCompare);
    },

    searchFabric(search) {
      if (search !== "") {
        this.rows = this.rowsOriginal.filter((obj) => {
          let strCode = Fabric.getCode(obj.id) + "";
          return (
            strCode === search ||
            obj.name.toLowerCase().includes(search.toLowerCase())
          );
        });
      } else {
        this.rows = this.rowsOriginal;
      }
    },

    sort(column) {
      this.sortType = this.sortType === "asc" ? "desc" : "asc";
      if (column === "delivery_date" || column === "out_of_stock_date") {
        this.rows = _.orderBy(
          this.rows,
          function (row) {
            return new Date(row[column]);
          },
          [this.sortType]
        );
      } else if (
        ["threadColor", "embroideryThreadColor", "buttonColor"].includes(column)
      ) {
        this.rows = _.orderBy(
          this.rows,
          function (row) {
            return row[column] ? row[column].internal_number : null;
          },
          [this.sortType]
        );
      } else if (column === "fabricSupplier") {
        this.rows = _.orderBy(
          this.rows,
          function (row) {
            return row[column] ? row[column].name : null;
          },
          [this.sortType]
        );
      } else {
        let module = this;
        this.rows = _.orderBy(
          this.rows,
          function (row) {
            let columnType = module.getColumnType(column);
            if (columnType === "numeric") {
              return row[column] || 0;
            } else {
              return row[column] || "";
            }
          },
          [this.sortType]
        );
      }
    },
    getColumnType(column) {
      for (let i in fabricColumns) {
        let info = fabricColumns[i];
        if (info.key === column) {
          return info.hasOwnProperty("type") ? info.type : "string";
        }
      }
    },
  },
};
</script>


<style scoped>
@import "~sweetalert2/dist/sweetalert2.min.css";
@import "~vue-good-table/dist/vue-good-table.css";

.header-row {
  margin-bottom: 20px;
}

.header-row .search-fabric {
  height: 38px;
}

.form-control {
  height: 38px;
}
.input-group-addon {
  height: 38px !important;
}
.img {
  height: 40px;
  width: 40px;
  border-radius: 5px;
}
.tiles-title {
  font-size: 14px;
  color: #4f5458;
  font-weight: bold;
}
hr {
  border-bottom: 0.02px solid #e6e6e6 !important;
  margin: 10px 0px 0px 0px !important;
}
.dropdown-menu {
  right: 0;
  left: auto;
  padding-left: 1px;
  padding-right: 1px;
  border: 1px solid #27a699;
}
.up-par {
  background: #f1f1f1;
}
.time-frame {
  margin-top: -33px !important;
  margin-bottom: 0px !important;
  float: right;
}

.table-div {
  overflow: scroll;
  height: 600px;
}
.table tr th {
  position: sticky !important;
  top: -1px;
  text-align: center;
}
</style>
